import React from 'react';
import PropTypes from 'prop-types';
import FieldGroup from '../FieldGroup';
import CheckboxControl from './CheckboxControl';
import FormField from '../FormField';

import i18n from '../../../../src/i18n/translate';

export default class MultipleSelectControl extends React.Component {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      checkboxValue: PropTypes.bool
    })),
    title: PropTypes.string,
    checkAllLabel: PropTypes.string,
    onValueChange: PropTypes.func,
    listClassName: PropTypes.string,
    wrapperClassName: PropTypes.string,
    CheckboxComponent: PropTypes.func,
    SearchInputComponent: PropTypes.func
  };

  static defaultProps = {
    CheckboxComponent: CheckboxControl,
    SearchInputComponent: FormField
  };

  constructor(props) {
    super(props);

    this.changeValue = this.changeValue.bind(this);
    this.handleSelectAllChange = this.handleSelectAllChange.bind(this);
    this.filterList = this.filterList.bind(this);
    this.validateAllInputsSelected = this.validateAllInputsSelected.bind(this);

    this.state = {
      data: props.data,
      checkAllValue: this.validateAllInputsSelected(props.data)
    };
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      data: newProps.data,
      checkAllValue: this.validateAllInputsSelected(newProps.data)
    });
  }

  changeValue(value, item) {
    item.checkboxValue = value;

    this.setState({
      data: this.state.data,
      checkAllValue: this.validateAllInputsSelected(this.state.data)
    }, () => this.props.onValueChange(this.state.data));
  }

  handleSelectAllChange(value) {
    const newData = this.state.data.map(item => {
      item.checkboxValue = value;
      return item;
    });

    this.setState({
      data: newData,
      checkAllValue: value
    }, () => this.props.onValueChange(this.state.data));
  }

  filterList(searchValue) {
    const filteredData = this.props.data.filter(item => item.label.toLowerCase().includes(searchValue.toLowerCase()));

    this.setState({
      data: filteredData,
      checkAllValue: this.validateAllInputsSelected(filteredData)
    });
  }

  validateAllInputsSelected(data) {
    return !(data.map(item => item.checkboxValue).indexOf(false) > -1);
  }

  renderList() {
    const { CheckboxComponent } = this.props;

    return this.state.data.map((item, index) =>
      <CheckboxComponent key={index}
        name={`item${index}`}
        label={i18n.t(item.label)}
        dataValue={item.checkboxValue}
        valueOverride={true}
        onValueChange={(value) => this.changeValue(value[`item${index}`], item)}
      />
    );
  }

  render() {
    const { CheckboxComponent, SearchInputComponent } = this.props;

    return (
      <div className={`multiple-select ${this.props.wrapperClassName}`}>
        {this.props.title ? <h4>{i18n.t(this.props.title)}</h4> : ''}

        {this.props.checkAllLabel ?
          <CheckboxComponent label={i18n.t(this.props.checkAllLabel)}
            name={'checkAll'}
            dataValue={this.state.checkAllValue}
            valueOverride={true}
            onValueChange={(value) => this.handleSelectAllChange(value.checkAll, true)}
          />
          : ''}

        <span>{i18n.t(`${this.state.data.filter(item => item.checkboxValue).length} selected items`)}</span>

        <div className={`list-wrapper ${this.props.listClassName}`}>
          <FieldGroup onValueChange={(data) => this.filterList(data.search)}>
            <SearchInputComponent name="search" caption={i18n.t(`Search`)} />
          </FieldGroup>

          {this.renderList()}
        </div>

      </div>
    );
  }
}
